export default __webpack_public_path__ + "static/media/Sammir-Dattani-Executive-Director-of-Sanathan-Textiles.207642a1.png";